import { z } from 'zod';

import { defineFcm } from '../shared/factory';

// A petition ID is often typed as a number, so one is accepted and stored as a string. A pasted URL,
// or a slug copied from a share link with its query string or fragment, would pass a plain string
// check and then resolve to nothing, so only slug characters are allowed at save.
const slugOrId = z
	.union([z.string(), z.int().nonnegative()])
	.transform(String)
	.pipe(
		z
			.string()
			.trim()
			.regex(/^[\w-]+$/, 'Use an ID or slug, not a URL (no "/", "?" or "#")'),
	);

// A decision maker response ID is always numeric, so swapping it with the petition slug is caught at save.
const responseId = z
	.union([z.string(), z.int().positive()])
	.transform(String)
	.pipe(z.string().trim().regex(/^\d+$/, 'Use the numeric response ID from the response URL'));

export const FCM_SOCIAL_LANDING_PAGE_CONTENT = defineFcm('social_landing_page_content')
	.asJson(
		z.object({
			victories: z.array(slugOrId),
			decisionMakerResponses: z.array(z.object({ id: responseId, petitionSlugOrId: slugOrId })),
			heroImageUrl: z.httpUrl().nullable(),
		}),
	)
	.withDefault({ victories: [], decisionMakerResponses: [], heroImageUrl: null })
	.toConfig({
		owner: 'squad-narwhal',
		scope: 'corgi-front-end',
		supportedGroups: { global: true, countries: true },
		context: 'Social Starter landing pages',
		description:
			'Curated content for the Social Starter landing pages, edited by design and PM. Lists are shown in order, and a page shows as many entries from the top as it has room for. Use IDs or slugs, not full URLs. "victories": petition IDs or slugs for the "Every day on Change.org" section. "decisionMakerResponses": a decision maker response ID plus its petition\'s ID or slug, both found in the response URL (/p/<petition-slug>/responses/<id>). "heroImageUrl": the image URL behind the hero animation (S3, Unsplash, or any other host), or null for none. All three keys are required; use [] for a list with no entries. A country row replaces the global row entirely rather than merging with it.',
		template: {
			victories: ['amend-maryland-s-phone-free-school-policy', 'save-peabody-high-chorale-programs'],
			decisionMakerResponses: [
				{ id: '47755', petitionSlugOrId: 'protect-neighbourhoods-from-the-trident-data-center' },
				{ id: '47493', petitionSlugOrId: 'provide-discounted-subsidized-or-free-omny-cards-for-cuny-students' },
			],
			heroImageUrl:
				'https://images.unsplash.com/photo-1532938911079-1b06ac7ceec7?q=80&w=2664&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
		},
	});
